/**
 * 러버밴드 오버스크롤 때만 드러나는 시그니처 레이어 (공대삼촌 공통).
 *
 * 본문 껍데기 뒤(`-z-10`)에 깔린 fixed 레이어라 평소엔 보이지 않는다. 화면
 * 끝에서 한 번 더 당겼을 때 위/아래로 한 마디씩 나온다.
 *
 * 모양은 전부 `styles.css` 의 `.overscroll-reveal` 이 진다.
 */
// 64px 높이로 그린다 — 2x(128px) WebP 로 줄였다(원본 png 480×400 89KB → 5KB). 해시 자산이라 1년 캐시.
import catImg from '../../assets/cat.webp';
import uncleImg from '../../assets/uncle.webp';

export function OverscrollReveal() {
  return (
    <>
      <div className="overscroll-reveal overscroll-reveal--top">
        <span>돈벌긴 어렵지만, 따먹긴 쉽다냥~</span>
        <img src={catImg} alt="" width={128} height={128} className="overscroll-reveal__img" />
      </div>

      <div className="overscroll-reveal overscroll-reveal--bottom">
        <span>
          오지랖 넓어, 줘도 못먹는 걸 못 참아하는
          <br />
          공대삼촌이 극강T의 힘을 보여주려고 만들었대.
        </span>
        <img src={uncleImg} alt="" width={154} height={128} className="overscroll-reveal__img" />
      </div>
    </>
  );
}
